<div class="container">
  <h1 class="title" *ngIf="data?.type !== 'privacy'">
    {{
      exchangeCountry === EXCHANGE_COUNTRY.CHL
        ? 'Términos y condiciones “CRYPTO“ y de “Vita Wallet"'
        : ('TERMS_AND_CONDITIONS' | translate)
    }}
  </h1>
  <h1 class="title" *ngIf="data?.type === 'privacy'">{{ 'POLICY' | translate }}</h1>

  <div class="info" *ngIf="data?.type !== 'privacy'">
    <p class="content manteca-scrollbar scrollbar-sm" [innerHtml]="tyc"></p>
  </div>
  <div class="info manteca-scrollbar scrollbar-sm" *ngIf="data?.type === 'privacy'">
    <p
      class="content manteca-scrollbar scrollbar-sm"
      [innerHtml]="privacyByCountry(exchangeCountry)"
    ></p>
  </div>
  <div class="options">
    <button appButton="primary" (click)="closeDialog()">{{ 'ACCEPT' | translate }}</button>
  </div>
</div>
